import { render, staticRenderFns } from "./MarketingPreferencesCampaigns.vue?vue&type=template&id=4592dfeb&scoped=true&"
import script from "./MarketingPreferencesCampaigns.vue?vue&type=script&lang=js&"
export * from "./MarketingPreferencesCampaigns.vue?vue&type=script&lang=js&"
import style0 from "./MarketingPreferencesCampaigns.vue?vue&type=style&index=0&id=4592dfeb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4592dfeb",
  null
  
)

export default component.exports